import { render, staticRenderFns } from "./GroupedPMLessonsList.vue?vue&type=template&id=2155237b&scoped=true&"
import script from "./GroupedPMLessonsList.vue?vue&type=script&lang=ts&"
export * from "./GroupedPMLessonsList.vue?vue&type=script&lang=ts&"
import style0 from "./GroupedPMLessonsList.vue?vue&type=style&index=0&id=2155237b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2155237b",
  null
  
)

export default component.exports